export const NAV = {
  logo: 'nav-logo',
  homeLink: 'nav-home-link',
  aboutLink: 'nav-about-link',
  contactLink: 'nav-contact-link',
  listenLiveBadge: 'nav-listen-live-badge',
  mobileMenuToggle: 'nav-mobile-menu-toggle',
};

export const PLAYER = {
  majesticPlay: 'majestic-player-play-button',
  majesticPause: 'majestic-player-pause-button',
  majesticVolume: 'majestic-player-volume-slider',
  jazzPlay: 'jazz-player-play-button',
  jazzPause: 'jazz-player-pause-button',
  jazzVolume: 'jazz-player-volume-slider',
};

export const HOME = {
  hero: 'home-hero',
  paypalCta: 'paypal-donation-cta',
  paypalCtaFloating: 'paypal-donation-cta-floating',
  carplayLink: 'carplay-external-link',
  jazzExternalLink: 'jazz-external-link',
  facebookLink: 'social-facebook-link',
  youtubeLink: 'social-youtube-link',
  oldiesRepertoryLink: 'oldies-repertory-link',
  emergentLink: 'emergent-link',
};

export const ABOUT = {
  page: 'about-page',
  genreMarquee: 'about-genre-marquee',
};

export const CONTACT = {
  page: 'contact-page',
  form: 'contact-form',
  nameInput: 'contact-form-name',
  emailInput: 'contact-form-email',
  messageInput: 'contact-form-message',
  submitBtn: 'contact-form-submit',
  emailLink: 'contact-email-link',
};

export const FOOTER = {
  root: 'site-footer',
  paypalLink: 'footer-paypal-link',
};
